import { Group } from "three";
import {addMeshToLayer} from "./LayerHandler";

import {archMatrix} from "./AnimationHandler";
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';


// Groupes globaux
const groupMaxiSetupOverlayTeeth = new Group();
groupMaxiSetupOverlayTeeth.name = "groupMaxiSetupOverlayTeeth";

const groupMandiSetupOverlayTeeth = new Group();
groupMandiSetupOverlayTeeth.name = "groupMandiSetupOverlayTeeth";

const groupMaxiMalocOverlayTeeth = new Group();
groupMaxiMalocOverlayTeeth.name = "groupMaxiMalocOverlayTeeth";

const groupMandiMalocOverlayTeeth = new Group();
groupMandiMalocOverlayTeeth.name = "groupMandiMalocOverlayTeeth";

threeEngine.setOverlayGroups({
    groupMaxiSetupOverlayTeeth,
    groupMandiSetupOverlayTeeth,
    groupMaxiMalocOverlayTeeth,
    groupMandiMalocOverlayTeeth
});

/**
* Fonction générique pour créer les dents overlay (maloc ou setup)
*/
export function createOverlayTeeth(importedMeshesGroup, type, material) {
    importedMeshesGroup.traverse((child) => {
        if (child.userData.type !== 0) return;

        const cloned = child.clone();
        const [, , id] = cloned.name.split("_");
        cloned.clear();
        cloned.name = `0_${type}OverlayTooth_${id}`;
        cloned.material = material;

        const arch = archMatrix[cloned.userData.jawType];
        addMeshToLayer(cloned, arch);

        const isMaxi = arch === "maxi";
        const groupMaxi = type === "Setup" ? threeEngine.getOverlayGroup("groupMaxiSetupOverlayTeeth") : threeEngine.getOverlayGroup("groupMaxiMalocOverlayTeeth");
        const groupMandi = type === "Setup" ? threeEngine.getOverlayGroup("groupMandiSetupOverlayTeeth") : threeEngine.getOverlayGroup("groupMandiMalocOverlayTeeth");

        if (isMaxi) {
            groupMaxi.add(cloned);
            ["malocMaxi", "setupMaxi", "comparativeMaxi"].forEach(layer =>
                addMeshToLayer(cloned, layer)
            );
        } else {
            cloned.visible = false;
            groupMandi.add(cloned);
            ["malocMandi", "setupMandi", "comparativeMandi"].forEach(layer =>
                addMeshToLayer(cloned, layer)
            );
        }
    });
}

/**
 * Active/désactive les différents overlays de dents (maloc / setup / none)
 */
export function activeOverlayTeeth(overlay) {
    const scene = threeEngine.getScene();
    if (!scene) return;

    const hideGroups = (...groups) => {
        groups.forEach(group => {
            group.traverse(child => (child.visible = false));
        });
    };

    const showGroups = (...groups) => {
        groups.forEach(group => {
            group.traverse(child => (child.visible = true));
        });
    };

    switch (overlay) {
        case "maloc":
            scene.remove(threeEngine.getOverlayGroup("groupMaxiSetupOverlayTeeth"));
            scene.add(threeEngine.getOverlayGroup("groupMaxiMalocOverlayTeeth"));
            // groupes mandi restent dans mandiGroup — visibilité seulement
            showGroups(threeEngine.getOverlayGroup("groupMandiMalocOverlayTeeth"));
            hideGroups(threeEngine.getOverlayGroup("groupMandiSetupOverlayTeeth"));
            break;

        case "setup":
            scene.remove(threeEngine.getOverlayGroup("groupMaxiMalocOverlayTeeth"));
            scene.add(threeEngine.getOverlayGroup("groupMaxiSetupOverlayTeeth"));
            // groupes mandi restent dans mandiGroup — visibilité seulement
            hideGroups(threeEngine.getOverlayGroup("groupMandiMalocOverlayTeeth"));
            showGroups(threeEngine.getOverlayGroup("groupMandiSetupOverlayTeeth"));
            break;

        default: // "none"
            scene.remove(
                threeEngine.getOverlayGroup("groupMaxiMalocOverlayTeeth"),
                threeEngine.getOverlayGroup("groupMaxiSetupOverlayTeeth")
            );
            // groupes mandi restent dans mandiGroup — visibilité seulement
            hideGroups(threeEngine.getOverlayGroup("groupMandiMalocOverlayTeeth"), threeEngine.getOverlayGroup("groupMandiSetupOverlayTeeth"));
            break;
    }
}

/**
 * Attache les groupes overlay mandi au mandiGroup pour qu'ils suivent le ByteJump.
 * À appeler une seule fois après que threeEngine.getMandiGroup() est disponible.
 */
export function attachMandiOverlayGroupsToMandiGroup() {
    const mandiGroup = threeEngine.getMandiGroup();
    if (!mandiGroup) return;
    mandiGroup.add(threeEngine.getOverlayGroup("groupMandiMalocOverlayTeeth"));
    mandiGroup.add(threeEngine.getOverlayGroup("groupMandiSetupOverlayTeeth"));
}

/**
 * Dispose all overlay groups and their contents
 */
export const disposeOverlayGroups = () => {
    const groups = [
        groupMaxiSetupOverlayTeeth,
        groupMandiSetupOverlayTeeth,
        groupMaxiMalocOverlayTeeth,
        groupMandiMalocOverlayTeeth
    ];

    groups.forEach(group => {
        group.traverse(child => {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
                if (Array.isArray(child.material)) {
                    child.material.forEach(m => m.dispose());
                } else {
                    child.material.dispose();
                }
            }
        });
        group.clear();
    });
}
